import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "tab-pane fade show active",
  id: "conversations-mobile-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "conversations-mobile-tab",
  tabindex: "0"
};
var _hoisted_2 = {
  key: 0,
  "class": "text-center mt-xxl-5 mt-3 pt-5 font-size-14"
};
import { ref, defineAsyncComponent } from 'vue';
import MessageRowMobile from '@dashboardApp/components/inbox/MessageRowMobile';
import ThreadLoader from '@dashboardApp/components/inbox/ThreadLoader';
import { useUserStore } from '@dashboardApp/stores/UserStore';
import { useInboxStore } from '@dashboardApp/stores/InboxStore';
export default {
  __name: 'ConversationsMobile',
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    /**
     * Note: Fetching of messages done in views/inbox/Inbox.vue
     */
    var AppTooltip = defineAsyncComponent(function () {
      return import( /* webpackChunkName: "app-tooltip" */'@dashboardApp/components/AppTooltip.vue');
    });
    var _useUserStore = useUserStore(),
      user = _useUserStore.user;
    var inboxStore = useInboxStore();
    var scrollEl = ref(null);
    var firstMessageReceivedEl = ref(null);
    function messageClicked() {
      if (firstMessageReceivedEl.value && user.allMessageCount === 1) {
        firstMessageReceivedEl.value.gotIt();
      }
    }

    /**
     * Expose scroll element for later hydration using useInfiniteScroll
     */
    __expose({
      scrollEl: scrollEl
    });
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [!_unref(inboxStore).hasConversations && _unref(inboxStore).messagesAreReady ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("img", {
        src: "/img/v5/db-illustration-inbox-empty.svg",
        "class": "img-fluid"
      }, null, -1)), _unref(user).isSupplier ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        "class": "opacity-80 my-4"
      }, "Here you’ll see your latest messages from customers who reached out to you.", -1)), _createVNode(_component_router_link, {
        to: "/supplier-dashboard",
        "class": "font-weight-semibold link-hover-underline"
      }, {
        "default": _withCtx(function () {
          return _cache[0] || (_cache[0] = [_createTextVNode(" Start uploading your product catalog ")]);
        }, undefined, true),
        _: 1
      })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        "class": "opacity-80 my-4"
      }, [_createTextVNode("Here you’ll see your latest messages from"), _createElementVNode("br"), _createTextVNode(" suppliers you have contacted.")], -1)), _createVNode(_component_router_link, {
        to: {
          name: 'directory-search-results-suppliers'
        },
        "class": "font-weight-semibold link-hover-underline"
      }, {
        "default": _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createTextVNode(" Start searching for suppliers ")]);
        }, undefined, true),
        _: 1
      })], 64))])) : _createCommentVNode("", true), _createElementVNode("div", {
        ref_key: "scrollEl",
        ref: scrollEl,
        "class": "d-flex flex-column list-messages"
      }, [_unref(inboxStore).hasConversations ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(inboxStore).messages, function (message) {
        return _openBlock(), _createBlock(_unref(MessageRowMobile), {
          key: message._jv.id,
          message: message,
          onClick: messageClicked
        }, null, 8, ["message"]);
      }), 128)) : _createCommentVNode("", true), _unref(inboxStore).messagesAreLoading ? (_openBlock(), _createBlock(_unref(ThreadLoader), {
        key: 1,
        variant: "mobile"
      })) : _createCommentVNode("", true)], 512)]), _unref(user).allMessageCount === 1 && !_unref(user).isSupplier ? (_openBlock(), _createBlock(_unref(AppTooltip), {
        key: 0,
        ref_key: "firstMessageReceivedEl",
        ref: firstMessageReceivedEl,
        metaKey: "dashboard_inbox_first_message_received",
        displayOnLoad: "",
        variant: "mobile",
        step: 1
      }, {
        message: _withCtx(function () {
          return _cache[5] || (_cache[5] = [_createTextVNode(" You've just received your first response from a supplier! Tap on the message to read it. ")]);
        }),
        _: 1
      }, 512)) : _createCommentVNode("", true)], 64);
    };
  }
};